module.exports = __webpack_public_path__ + "img/POSASSISTANT_APP_IOS.3318fed2.png";